import * as types from 'store/mutation-types'
import {
  createStockAlert,
  deleteStockAlert,
  getAllStockAlerts,
  getStockAlert,
  updateStockAlert
} from 'apis/push'
import { PRICE_ALERT_TYPE } from 'const/stock'

const state = {
  activeTab: 'new',
  allAlerts: null, // 所有的股价提醒
  curStock: null, // 当前标的信息
  curAlerts: null, // 当前标的股价提醒
  editAlert: null // 正在编辑的提醒
}

const getters = {
  priceAlertActiveTab(state) {
    return state.activeTab
  },
  priceAlertStock(state) {
    return state.curStock
  },
  priceAlertAll(state) {
    return state.allAlerts
  },
  priceAlertCur(state) {
    return state.curAlerts
  },
  priceAlertEdit(state) {
    return state.editAlert
  }
}

const mutations = {
  [types.SWITCH_PRICE_ALERT_TAB](state, tab) {
    state.activeTab = tab
  },
  [types.UPDATE_PRICE_ALERT_STOCK](state, stock) {
    state.curStock = stock
  },
  [types.UPDATE_PRICE_ALERT_ALL](state, alerts) {
    state.allAlerts = alerts
  },
  [types.UPDATE_PRICE_ALERT_CUR](state, alerts) {
    state.curAlerts = alerts
  },
  [types.UPDATE_PRICE_ALERT_EDIT](state, alert) {
    state.editAlert = alert
  },
  [types.UPDATE_PRICE_ALERT_LIST](state, alert) {
    if (state.curAlerts) {
      state.curAlerts.item.forEach(item => {
        if (item.id === alert.id) {
          Object.assign(item, alert)
        }
      })
    }
    if (state.allAlerts) {
      (state.allAlerts.items || []).forEach(mk => {
        (mk.item || []).forEach(item => {
          if (item.id === alert.id) {
            Object.assign(item, alert)
          }
        })
      })
    }
  },
  [types.DELETE_PRICE_ALERT](state, id) {
    if (state.curAlerts) {
      for (let i = 0; i < state.curAlerts.item.length; i++) {
        const item = state.curAlerts.item[i]
        if (item.id === id) {
          state.curAlerts.item.splice(i, 1)
          break
        }
      }
    }
    if (state.allAlerts && state.allAlerts.items) {
      for (let i = 0; i < state.allAlerts.items.length; i++) {
        const mk = state.allAlerts.items[i]
        for (let j = 0; j < mk.item.length; j++) {
          const item = mk.item[j]
          if (item.id === id) {
            mk.item.splice(j, 1)
            break
          }
        }
      }
    }
    // 如果删除了正在编辑的提醒，则清空编辑信息
    if (state.editAlert && state.editAlert.id === id) {
      state.editAlert = null
    }
  }
}

const actions = {
  getAllStockAlerts({ commit }) {
    return getAllStockAlerts().then(d => {
      if (d.ret === 0 && d.data) {
        d.data.items = d.data.items || []
        // FIXME: 过滤 Web 端不支持的股价提醒数据
        d.data.items.forEach(alt => {
          alt.item = (alt.item || []).filter(item => {
            return (
              [
                PRICE_ALERT_TYPE.YEAR_HIGHEST,
                PRICE_ALERT_TYPE.YEAR_LOWEST
              ].indexOf(item.alertType) < 0
            )
          })
        })
        commit(types.UPDATE_PRICE_ALERT_ALL, d.data)
        return d.data
      }
      throw d
    })
  },
  getCurStockAlerts({ commit, state }) {
    if (!state.curStock) return
    const { market, symbol } = state.curStock
    return getStockAlert({ symbol, market, page: 0, size: 500 }).then(d => {
      if (d.ret === 0 && d.data) {
        // FIXME: 过滤 Web 端不支持的股价提醒数据
        d.data.item = (d.data.item || []).filter(item => {
          return (
            [
              PRICE_ALERT_TYPE.YEAR_HIGHEST,
              PRICE_ALERT_TYPE.YEAR_LOWEST
            ].indexOf(item.alertType) === -1
          )
        })
        commit(types.UPDATE_PRICE_ALERT_CUR, d.data)
        return d.data
      }
      throw d
    })
  },
  setPriceAlertStock({ commit }, stock) {
    commit(types.UPDATE_PRICE_ALERT_STOCK, stock)
    if (!stock) commit(types.UPDATE_PRICE_ALERT_CUR, null)
  },
  setPriceAlertEdit({ commit }, alert) {
    commit(types.UPDATE_PRICE_ALERT_EDIT, alert)
  },
  setPriceAlertTab({ commit, dispatch }, tab) {
    commit(types.SWITCH_PRICE_ALERT_TAB, tab)
    if (tab === 'new') {
      dispatch('getCurStockAlerts')
    } else {
      dispatch('getAllStockAlerts')
    }
  },
  createPriceAlert({ dispatch, state }, payload) {
    return createStockAlert(payload).then(d => {
      if (d.ret === 0) {
        dispatch('getAllStockAlerts')
        dispatch('getCurStockAlerts')
        return d
      }
      throw d
    })
  },
  deletePriceAlert({ dispatch, commit }, id) {
    return deleteStockAlert(id).then(d => {
      if (d.ret === 0) {
        commit(types.DELETE_PRICE_ALERT, id)
        return d
      }
      throw d
    })
  },
  updatePriceAlert({ commit, dispatch }, payload) {
    return updateStockAlert([payload]).then(d => {
      if (d.ret === 0) {
        commit(types.UPDATE_PRICE_ALERT_LIST, payload)
        return d
      }
      throw d
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
